/**
 * Created by pandemio on 4/2/19.
 */
import React from 'react';
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Form,
    Button
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUsers} from '@fortawesome/free-solid-svg-icons';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import UsersDataTable from '../datatables/users-data-table';
import ModalUpdateUserDetails from '../modals/modal-update-user-details';

/**
 * The component (window) to handle the user details
 */
class UsersSearch extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            didMount: false,
            userId: null,
            loading: false,
            showModal: false,
            showUserModal: false,
            propsModal: null,
            isEdit: true,
            redoSearch: false
        };
        this.props.addTranslation(global);

        this.handleUserSelection = this.handleUserSelection.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleUpdateModal = this.toggleUpdateModal.bind(this);
        this.handleNewUser = this.handleNewUser.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.setState({didMount: true});
        this.resize();
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    /** Toggle the update plan modal **/
    toggleUpdateModal(e){
        this.setState({
            showUserModal: e,
            redoSearch: true
        });
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handleUserSelection(e) {
        this.setState({
            userId: e,
            showUserModal: true
        });
    }

    handleNewUser(){
        this.setState({
            userId: null,
            showUserModal: true,
            isEdit: false
        });
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}

                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faUsers}/>{' '}
                            <Translate id="user-management.users"/>
                        </h2>
                        <small className="white-text">
                            <Translate id="user-management.users-instructions"/>
                        </small>
                        <hr/>
                        <Button color="warning" onClick={this.handleNewUser}>
                            <Translate id="user-management.add-new"/>
                        </Button>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-white">
                                    <CardBody>
                                        <Form>
                                            <UsersDataTable redoSearch={this.state.redoSearch} updateParent={this.handleUserSelection}/>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr/>
                    </Container>
                </div>
                <Footer/>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showUserModal ?
                    <ModalUpdateUserDetails userId={this.state.userId} isEdit={this.state.isEdit}
                                visible={this.state.showUserModal} updateParent={this.toggleUpdateModal}/> : null
                }
            </div>
        )
    };
}

export default withLocalize(UsersSearch);